export default class AnimationAppear {
    constructor(selector) {
        // Property
        if(typeof selector === "string") {
            this.elements = document.querySelectorAll(selector);
        } else {
            this.elements = selector.reduce((carry, item) => {
                if(document.querySelectorAll(item).length) {
                    document.querySelectorAll(item).forEach(el => {
                        carry.push(el);
                    });
                }
                return carry;
            }, []);
        }

        // Method
        this.init();
    }

    init() {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry, index) => {
                if(entry.isIntersecting) {
                    const nodes = Array.prototype.slice.call(entry.target.parentElement.children);
                    const countNodesDisplay = Array.prototype.slice.call(entry.target.parentElement.querySelectorAll('.animation__appear--view')).length;

                    const timeSecond = nodes.indexOf(entry.target) <= index
                        ? nodes.indexOf(entry.target) + 1
                        : (nodes.indexOf(entry.target) - countNodesDisplay) + 1
                    ;

                    entry.target.style.animationDelay = (timeSecond/4)+'s';
                    entry.target.classList.add('animation__appear--view');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: "20px 0px 20px 0px",
        });

        this.elements.forEach(element => {
            observer.observe(element);
        });
    }
}